import { de } from "./locales/de"

export const translations = {
  de
}